import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ValidaCrearCuentaExitoService implements CanActivate {
  preLogin: any;
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem('crearCuentaDatos')) {
      return true;
    } else {
      /* // Si no esta activa la sesion, redirecciona al login
      console.log("Security");*/
      this.router.navigate(['inicio']);
      return false;
    }

  }

}